export const INBOX = 'inbox'
export const KB = 'kb'
